import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Grid,
  Card,
  Button,
  Tooltip,
  TextField,
  Typography,
  CardContent,
} from "@mui/material";
import {
  DataGrid,
  esES,
  GridToolbar,
  GridActionsCellItem,
} from "@mui/x-data-grid";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import EditIcon from "@mui/icons-material/Edit";
import SendIcon from "@mui/icons-material/Send";
import DeleteIcon from "@mui/icons-material/Delete";
import Autocomplete from "@mui/material/Autocomplete";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import "../assets/css/modal.css";
import { ModalComponent } from "../app/common/ModalComponent";
import RenderStatus from "../app/common/RenderStatus";
import FormProveedores from "../components/proveedores/FormProveedores";
import { Status } from "../app/util/constants";
import { RootStoreContext } from "../app/store/root";
import DeleteDialog from "../app/common/DeleteDialog";
import DialogComponent from "../app/common/DialogComponent";
import { account } from "../shared/Utils";
import { useNavigate } from "react-router-dom";
import { Menu, Acciones } from "../app/util/permisos";
import NoRowsInDataGrid from "../shared/components/NoRowsInDataGrid";
import NoResultsInDataGrid from "../shared/components/NoResultsInDataGrid";

const log = console;
const ProveedoresPage = () => {
  const navigate = useNavigate();
  const rootStore = useContext(RootStoreContext);
  const {
    filter,
    entities,
    sendCode,
    setFilter,
    deleteProveedor,
    getAll,
    getAllByFilter,
    activeOrInactive,
  } = rootStore.proveedorStore;
  const { setRowDelete } = rootStore.deleteStore;

  /* UseStates */
  const [id, setId] = useState(undefined);
  const [model, setModel] = useState(undefined);
  const [openModal, setOpenModal] = useState(null);
  const [pageSize, setPageSize] = useState(5);
  const [permisosUsuario, setPermisosUsuario] = useState([]);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const [showDialog, setShowDialog] = useState(false);
  const [typeAction, setTypeAction] = useState(undefined);
  const [messageDialog, setMessageDialog] = useState(undefined);
  /* End UseStates */

  useEffect(() => {
    document.title = "Lilofy | Proveedores";
    if (
      !account
        .getPermisosUsuario()
        .some((a) => a.clavePermiso == Menu.Proveedores && a.tienePermiso)
    ) {
      console.log("No tengo permisos para la Proveedores");
      navigate("/Usuarios/AccessDenied");
    } else {
      setPermisosUsuario(account.getPermisosUsuario());
      getAll(true);
      setFilter(Status[0]);
    }
  }, []);

  /* Methods */
  const updateProveedor = (params) => {
    const row = toJS(params.row);
    if (row && Object.keys(row).length > 0) {
      setId(row.id);
      setModel({
        IdProveedor: row.id,
        NombreProveedor: row.proveedores,
        Correo: row.correo,
        Telefono: row.telefono,
        NumeroLicencias: row.numCuentas,
      });
      setOpenModal(true);
    }
  };
  const clearFormModel = () => {
    setId(undefined);
    setModel(undefined);
    setOpenModal(false);
  };
  const clearDeleteModel = () => {
    setId(undefined);
    setRowDelete(undefined);
    setShowDeleteDialog(false);
  };

  const handleClose = (event, reason) => {
    if (reason && reason == "backdropClick") return;
    setOpenModal(false);
  };
  /* End Methods */

  const columns = [
    /* {
      field: "nombreEmpresa",
      headerName: "Nombre Empresa",
      minWidth: 150,
      flex: 1,
      headerClassName: "tableHeaders",
    }, */
    {
      field: "proveedores",
      headerName: "Nombre del proveedor",
      minWidth: 150,
      flex: 1,
      headerClassName: "tableHeaders",
      renderHeader: () => (
        <span className="headerTable">Nombre del proveedor</span>
      ),
    },
    {
      field: "correo",
      headerName: "Correo electrónico",
      minWidth: 150,
      flex: 1,
      headerClassName: "tableHeaders",
      renderHeader: () => (
        <span className="headerTable">Correo electrónico</span>
      ),
    },
    {
      field: "telefono",
      headerName: "Teléfono",
      sortable: true,
      minWidth: 150,
      flex: 0.5,
      headerClassName: "tableHeaders",
      renderHeader: () => <span className="headerTable">Teléfono</span>,
    },
    {
      field: "numCuentas",
      headerName: "Número de cuentas",
      sortable: true,
      minWidth: 150,
      flex: 0.5,
      align: "center",
      headerClassName: "tableHeaders",
      renderHeader: () => (
        <span className="headerTable">Número de cuentas</span>
      ),
    },
    {
      field: "codigoRegistro",
      headerName: "Código de registro",
      sortable: true,
      minWidth: 150,
      flex: 0.5,
      headerClassName: "tableHeaders",
      renderHeader: () => (
        <span className="headerTable">Código de registro</span>
      ),
    },
    {
      field: "estatus",
      headerName: "Estatus",
      sortable: true,
      renderCell: (row) => (
        <RenderStatus
          Row={row}
          FieldName="proveedor"
          NameRow={row.row.proveedores}
          MessageWhenInactive="Si hace esto las cuentas ligadas al proveedor se verán afectadas con el mismo estatus asignado."
          PermisoEditar={permisosUsuario.some(
            (a) =>
              a.clavePermiso === Acciones.Editar_estatus_proveedor &&
              a.tienePermiso
          )}
          OnFinish={(idEstatus) => {
            activeOrInactive({
              IdProveedor: row.row.id,
              IdEstatus: idEstatus,
            });
          }}
        />
      ),
      minWidth: 200,
      flex: 0.5,
      headerClassName: "tableHeaders",
      renderHeader: () => <span className="headerTable">Estatus</span>,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Acciones",
      headerClassName: "tableHeaders",
      getActions: (params) => [
        <Tooltip title="Enviar Código" placement="top">
          <GridActionsCellItem
            icon={<SendIcon />}
            label="Enviar código"
            color="primary.main"
            hidden={
              !permisosUsuario.some(
                (a) =>
                  a.clavePermiso === Acciones.Enviar_código_de_registro && a.tienePermiso
              )
            }
            onClick={() => {
              const row = toJS(params.row);
              if (row && Object.keys(row).length > 0) {
                setId(row.id);
                setTypeAction("resendCode");
                setMessageDialog(
                  `¿Seguro que quiere enviar el código de registro a esta cuenta? Correo electrónico: ${row.correo}`
                );
                setShowDialog(true);
              }
            }}
          />
        </Tooltip>,
        <Tooltip title="Editar" placement="top">
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Editar"
            color="primary.main"
            hidden={
              !permisosUsuario.some(
                (a) =>
                  a.clavePermiso === Acciones.Editar_proveedor && a.tienePermiso
              )
            }
            onClick={() => updateProveedor(params)}
            renderCell={() => updateProveedor(params)}
          />
        </Tooltip>,
        <Tooltip title="Eliminar" placement="top">
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Eliminar"
            color="primary.main"
            hidden={
              !permisosUsuario.some(
                (a) =>
                  a.clavePermiso === Acciones.Eliminar_proveedor &&
                  a.tienePermiso
              )
            }
            onClick={() => {
              const row = toJS(params.row);
              if (row && Object.keys(row).length > 0) {
                setRowDelete({
                  NameRow: row.proveedores,
                  MessageWhenDelete: `Si hace esto las cuentas de usuario que se tienen ligadas al proveedor también se eliminarán. No de cuentas: ${row.numCuentas}`,
                });
                setId(row.id);
                setShowDeleteDialog(true);
              }
            }}
          />
        </Tooltip>,
      ],
    },
    {
      field: "cantidadCuentas",
      headerName: "CantidadCuentas",
      hide: true,
      renderHeader: () => (
        <span className="headerTable">Cantidad de cuentas</span>
      ),
    },
  ];

  return (
    <>
      <div className="main-container">
        <div className="mb-2">
          <Typography color="primary" variant="h4">
            <LocalShippingIcon sx={{ marginRight: 2 }} fontSize="large" />
            Proveedores
          </Typography>
        </div>
        <Card className="card">
          <CardContent>
            <Grid
              container
              direction={"row"}
              justifyContent="end"
              alignItems={"center"}
            >
              <Grid item>
                {permisosUsuario.some(
                  (a) =>
                    a.clavePermiso === Acciones.Alta_proveedor && a.tienePermiso
                ) && (
                  <Button
                    onClick={() => {
                      setId(undefined);
                      setOpenModal(true);
                      setModel(undefined);
                    }}
                    variant="contained"
                  >
                    Nuevo proveedor
                  </Button>
                )}
              </Grid>
            </Grid>
            <Grid
              container
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              direction={"row"}
              alignItems={"center"}
              mb={1}
            >
              <Grid item xs="12" sm="6" md="3" lg="2">
                {/* <SelectSearchComponent
                  Value={filter}
                  OnChange={(e) => {
                    setFilter(e.target.value);
                  }}
                  Placeholder="Estatus"
                  Options={{ options: Status }}
                /> */}
                <Autocomplete
                  size="small"
                  value={filter}
                  options={Status}
                  id="combo-box-proveedores"
                  sx={{ width: "100%" }}
                  onChange={(event, value) => {
                    setFilter(value);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Estatus" />
                  )}
                />
              </Grid>

              <Grid item>
                <Button
                  onClick={() => {
                    getAllByFilter(
                      filter?.value !== 1 ? { IdEstatus: filter?.value } : {}
                    );
                  }}
                  variant="contained"
                >
                  Buscar
                </Button>
              </Grid>
            </Grid>

            <Box
              sx={{
                width: "100%",
                "& .tableHeaders": {
                  color: "primary.main",
                },
                marginBottom: "1rem",
                marginTop: "0.5rem",
              }}
            >
              <DataGrid
                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                autoHeight
                rows={entities}
                columns={columns}
                dataSource={entities}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[5, 10, 20]}
                pagination
                disableColumnFilter
                disableColumnSelector
                disableDensitySelector
                components={{
                  Toolbar: GridToolbar,
                  NoRowsOverlay: () => <NoRowsInDataGrid />,
                  NoResultsOverlay: () => <NoResultsInDataGrid />,
                }}
                componentsProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                    csvOptions: { disableToolbarButton: true },
                    printOptions: { disableToolbarButton: true },
                  },
                }}
              />
            </Box>
          </CardContent>
        </Card>
      </div>
      <ModalComponent
        Open={openModal}
        HandleClose={handleClose}
        ClassName="modal-xl"
        Body={() => (
          <FormProveedores
            data={model}
            onFinish={() => {
              clearFormModel();
            }}
            onClose={handleClose}
          />
        )}
      />
      <DeleteDialog
        Open={showDeleteDialog}
        FieldName="al proveedor"
        OnClose={() => {
          clearDeleteModel();
        }}
        OnFinish={() => {
          deleteProveedor(id).then(() => {
            clearDeleteModel();
          });
        }}
      />
      <DialogComponent
        Open={showDialog}
        Message={messageDialog}
        OnClose={() => setShowDialog(false)}
        OnAccept={() => {
          if (typeAction === "resendCode") {
            sendCode(id);
            setId(undefined);
          }
          setShowDialog(false);
          setTypeAction(undefined);
          setMessageDialog(undefined);
        }}
      />
    </>
  );
};

export default observer(ProveedoresPage);
